import { normalizeApiError } from './errors.js';

export type NoUrl<T> = Omit<T, 'url'>;

type GeneratedResult<T> = {
  data?: T;
  error?: unknown;
  response?: Response;
};

export async function unwrapGenerated<T>(promise: Promise<GeneratedResult<T>>): Promise<T> {
  const result = await promise;
  if (result.error !== undefined) {
    if (result.error instanceof Error) throw result.error;
    // `result.error` is the parsed JSON error body (or a raw string) straight from
    // the server — see QG-CLI-COMP-002.
    throw normalizeApiError(result.error, result.response?.status ?? 0);
  }
  if (result.data === undefined) {
    throw new Error('API response body was empty');
  }
  return result.data;
}
